import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M12 12l3 2","key":"svg-1"}],["path",{"d":"M12 7v5","key":"svg-2"}]]

const IconClockHour4 = createReactComponent('outline', 'clock-hour-4', 'ClockHour4', __iconNode);

export default IconClockHour4;